window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;

var Thm = {
  init: function () {
    this.Basic.init();
  },
  Basic: {
    init: function () {
      this.smoothScroll();
      this.marqueeScroller();
      this.slideshowSwiper();
      this.TabSlider();
      this.thubnailSlider();
      this.collapsibleContent();
      this.tab_content()
      this.buyNowButton();
      this.sticky_header();
      this.video_media();
    },
    video_media: function(){
      class THMLazyLoadingVideo extends HTMLElement {
        constructor() {
          super(),
            (this.iframe = this.querySelector("iframe")),
            (this.template = this.querySelector("template")),
            (this.isMouseenter = !1);
        }
        loadVideo() {
          var t;
          this.iframe &&
            (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
            this.iframe.addEventListener(
              "load",
              function () {
                "youtube" == this.dataVideoType &&
                  this.iframe.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  ),
                  "vimeo" == this.dataVideoType &&
                    this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
              }.bind(this)
            )),
            "local_video" == this.dataVideoType &&
              ((this.local_video = this.querySelector("video")),
              (t = this.local_video.querySelector("source").getAttribute("data-src")),
              (this.local_video.src = t));
        }
        execute() {
          Shopify.designMode
            ? this.loadVideo()
            : (["mousemove", "touchstart"].forEach(
                function (t) {
                  THMHelper.qs("body").addEventListener(
                    t,
                    function (t) {
                      this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                    }.bind(this),
                    { once: !0 }
                  );
                }.bind(this)
              ),
              window.addEventListener(
                "scroll",
                function (t) {
                  this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                }.bind(this),
                { once: !0 }
              ));
        }
        static get observedAttributes() {
          return ["data-video-type", "data-video-id"];
        }
        set dataVideoType(t) {
          this.setAttribute("data-video-type", t);
        }
        get dataVideoType() {
          return this.getAttribute("data-video-type");
        }
        set dataVideoId(t) {
          this.setAttribute("data-video-id", t);
        }
        get dataVideoId() {
          return this.getAttribute("data-video-id");
        }
        attributeChangedCallback(t, e, s) {
          e !== s && this.execute();
        }
        connectedCallback() {
          this.execute();
        }
        disconnectedCallback() {}
      }
      customElements.define("thm-load-video", THMLazyLoadingVideo);

      class THMLoadMedia extends HTMLElement {
        constructor() {
          super(),
            (this.$ = this.querySelector.bind(this)),
            (this.sectionID = this.dataset.sectionId),
            (this.idVideo = this.dataset.idVideo),
            (this.typeVideo = this.dataset.type),
            (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
            (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
            (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
            (this.trigger = this.$(".js-load-media-trigger")),
            this.trigger &&
              this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
        }
        handlePlayVideo() {
          this.classList.add("playing");
          this.loadContent();
          const t = this.querySelector(".js-media-item-video");
          t &&
            t.addEventListener("play", () => {
              this.pauseAllVideo(t), t.play();
            });
        }
        onYouTubeIframeAPIReady() {
          if ("undefined" != typeof YT && void 0 !== YT.Player)
            try {
              this.player = new YT.Player(this.eleVideo, {
                videoId: this.idVideo,
                playerVars: { playsinline: 1 },
                events: {
                  onReady: this.onPlayerYTReady,
                  onStateChange: this.onPlayerStateYTChange,
                },
              });
            } catch (t) {
              console.error("Lỗi khi tạo trình phát YouTube:", t);
            }
          else {
            var t = document.createElement("script"),
              e =
                ((t.src = "https://www.youtube.com/iframe_api"),
                (t.onload = () => {
                  this.onYouTubeIframeAPIReady();
                }),
                document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
          }
        }
        onVimeoIframeAPIReady() {
          if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
            try {
              var t = { id: this.idVideo, autoplay: 1 };
              (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
                this.playerVimeo.on("play", () => {
                  this.pauseAllVideo(this.playerVimeo);
                });
            } catch (t) {
              console.error("Lỗi khi tạo trình phát Vimeo:", t);
            }
          else {
            var t = document.createElement("script"),
              e =
                ((t.src = "https://player.vimeo.com/api/player.js"),
                (t.onload = () => {
                  this.onVimeoIframeAPIReady();
                }),
                document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
          }
        }
        onPlayerYTReady = () => {
          this.pauseAllVideo(this.player), this.player.playVideo();
        };
        onPlayerStateYTChange = (t) => {
          1 == t.data && this.onPlayerPlay();
        };
        onPlayerPlay = () => {
          this.pauseAllVideo(this.player);
        };
        loadContent() {
          if (!this.getAttribute("loaded")) {
            if (this.$("template")) {
              var t = this.$("template").content.firstElementChild.cloneNode(!0);
              this.appendChild(t),
                this.isLoaded(!0),
                this.trigger && this.trigger.remove();
            } else {
              if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
              else {
                if ("vimeo" != this.typeVideo) return !0;
                this.onVimeoIframeAPIReady();
              }
              this.trigger?.classList.add("d-none"),
                this.$(".js-media-item").classList.add("d-flex");
            }
            return !0;
          }
        }
        pauseAllVideo(e) {
          THMHelper.qsa(
            ".js-product-media-deferred-video:has([data-type='youtube']"
          ).forEach((t) => {
            t.player && e !== t.player && t.player?.pauseVideo();
          }),
          THMHelper.qsa(
              ".js-product-media-deferred-video:has([data-type='vimeo'])"
            ).forEach((t) => {
              t.playerVimeo !== e && t.playerVimeo?.pause();
            }),
            THMHelper.qsa(".js-media-item-video").forEach((t) => {
              t !== e && t.pause();
            });
        }
        isLoaded(t) {
          t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
        }
      }
      customElements.define("thm-load-media", THMLoadMedia);
    },
    tab_content: function () {
      if (!customElements.get('tabbed-content')) {
        class Tabs extends HTMLElement {
          constructor() {
            super();
            this.tabList = this.querySelector('[role="tablist"]');
            this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
            this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
            this.tabs = this.querySelectorAll('[role="tab"]');
            this.panels = this.querySelectorAll('[role="tabpanel"]');
      
            // If no tab is active by default, activate the first tab.
            if (!this.activeTab) {
              this.activeTab = this.tabs[0];
              this.activateTab(this.activeTab);
            }
      
            this.addListeners();
          }
      
          addListeners() {
            this.tabList.addEventListener('click', this.handleClick.bind(this));
            this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
          }
      
          handleClick(evt) {
            if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
            this.activateTab(evt.target);
      
          }
      
          handleKeydown(evt) {
            switch (evt.key) {
              case 'ArrowLeft':
              case 'ArrowRight':
                evt.preventDefault();
                if (!this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'ArrowUp':
              case 'ArrowDown':
                evt.preventDefault();
                if (this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'Home':
                evt.preventDefault();
                this.activateTab(this.tabs[0]);
                break;
      
              case 'End':
                evt.preventDefault();
                this.activateTab(this.tabs[this.tabs.length - 1]);
                break;
            }
          }
      
          switchTabOnKeyPress(key) {
            if (key === 'ArrowRight' || key === 'ArrowDown') {
              if (this.activeTab === this.tabs[this.tabs.length - 1]) {
                this.activateTab(this.tabs[0]);
              } else {
                this.activateTab(this.activeTab.nextElementSibling);
              }
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
              if (this.activeTab === this.tabs[0]) {
                this.activateTab(this.tabs[this.tabs.length - 1]);
              } else {
                this.activateTab(this.activeTab.previousElementSibling);
              }
            }
          }
      
          activateTab(tab) {
            this.deactivateActiveTab();
      
            Tabs.setTabState(tab, true);
            tab.removeAttribute('tabindex');
            this.activeTab = tab;
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              panel.classList.add('fade-in');  // Add animation class
      
              setTimeout(() => {
                panel.classList.remove('fade-in');
              }, 500);
            }
      
            if (document.activeElement.matches('.tablist__tab')) {
              tab.focus();
            }
          }
      
          deactivateActiveTab() {
            Tabs.setTabState(this.activeTab, false);
            this.activeTab.setAttribute('tabindex', '-1');
            this.activeTab = null;
          }
      
          static setTabState(tab, active) {
            tab.setAttribute('aria-selected', active);
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              if (active) {
                panel.hidden = false;
              } else {
                panel.hidden = true;
              }
            }
          }
      
        }
      
        customElements.define('tabbed-content', Tabs);
      }
    },
    sticky_header: function () {
      var header = document.querySelector('[data-sticky-type="always"]');

      if(header != null){
        onScroll = () => {
          var scrolledPage = Math.round(window.pageYOffset);
          if (scrolledPage > 80) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }
        }
        document.addEventListener('scroll', onScroll);
      }

    },
    smoothScroll: function () {
      document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach(a => {
        a.addEventListener('click', function (e) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
            if (target) {
              e.preventDefault();
              window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
              setTimeout(() => {
                target.focus();
                if (!target.matches(':focus')) {
                  target.setAttribute('tabindex', '-1');
                  target.focus();
                }
              }, 600);
            }
          }
        });
      });

    },
    marqueeScroller: function () {
      if (!customElements.get("marquee-content")) {
        class Marquee extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          calculationPaddingSection() {
            (this.heightSection = this.offsetHeight),
              (this.heightSection =
                this.heightSection < 18
                  ? 18
                  : 96 < this.heightSection
                    ? 96
                    : this.heightSection),
              this.closest(".js-running-content").style.setProperty(
                "--spacing-padding-block",
                this.heightSection + "px"
              );
          }
          init() {
            (this.distance =
              this.querySelector(".js-marquee-item").offsetWidth),
              (this.speed = this.dataset.speed),
              this.style.setProperty(
                "--marquee-duration",
                this.distance / this.speed + "s"
              );
          }
        }
        customElements.define("marquee-content", Marquee);
      }
    },
    slideshowSwiper: function () {

      class slideshowSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.sliderWrapper = this.querySelector(".slideshow__swiper");

          let centered_slides =
            this.sliderWrapper.dataset.centeredslides !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
              : undefined;
          let effect_fade =
            this.sliderWrapper.dataset.effectfade !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.effectfade)
              : undefined;
              let nextButton = this.querySelectorAll(".swiper-button-next-custom");
              let prevButton = this.querySelectorAll(".swiper-button-prev-custom");

              let next = this.querySelector(".swiper-button-next");
              let prev = this.querySelector(".swiper-button-prev");

          let pagination = this.querySelector(".swiper-pagination");
          let scroll = this.querySelector(".swiper-scrollbar");

          const swiper =  new Swiper(this.sliderWrapper, {
            effect: effect_fade ? "fade" : "slide",
            centeredSlides: centered_slides ? centered_slides : false,
            slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
            grabCursor: false,
            horizontal: true,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
            loop: JSON.parse(this.sliderWrapper.dataset.loop),
            speed: 700,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            mousewheel: {
              forceToAxis: true,
            },
            autoplay: {
              enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
              disableOnInteraction: false,
              delay: parseInt(this.sliderWrapper.dataset.delay),
            },
    
            pagination: {
              el: pagination,
              clickable: true,
            },
            scrollbar: {
              el: scroll,
              draggable: true,
            },
            breakpoints: {
              359: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              },
              768: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
              },
              1024: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
              },
            }
          });
                        // Manually bind all next/prev buttons to swiper
              nextButton.forEach((btn) => {
                btn.addEventListener("click", () => swiper.slideNext());
              });

              prevButton.forEach((btn) => {
                btn.addEventListener("click", () => swiper.slidePrev());
              });

                 // Disable/hide custom buttons at edges when loop is false
    const updateCustomNavState = () => {
      if (!swiper.params.loop) {
        nextButton.forEach((btn) => {
          btn.disabled = swiper.isEnd;
          btn.classList.toggle("swiper-button-disabled", swiper.isEnd);
          // btn.style.display = swiper.isEnd ? "none" : ""; // Uncomment to HIDE instead of disable
        });
        prevButton.forEach((btn) => {
          btn.disabled = swiper.isBeginning;
          btn.classList.toggle("swiper-button-disabled", swiper.isBeginning);
          // btn.style.display = swiper.isBeginning ? "none" : ""; // Uncomment to HIDE instead of disable
        });
      }
    };

    swiper.on("init", updateCustomNavState);
    swiper.on("slideChange", updateCustomNavState);
    updateCustomNavState(); // Initial call


        }
      }
      customElements.define("slideshow-swiper", slideshowSwiper);



      

    },
    thubnailSlider: function () {
 
      
      
      
      var sliderThumbnail = new Swiper('.slider-thumbnail', {
        centeredSlides: true,
        centeredSlidesBounds: true, 
        direction: "horizontal",
        spaceBetween: 80,
        slidesPerView: 4,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        breakpoints: {
          359: {
            spaceBetween: 30,
            slidesPerView: 2,
            centeredSlides: false,
          },
          768: {
            spaceBetween: 30,
            slidesPerView: 3,
            centeredSlides: true,
          },
          1024: {
            spaceBetween: 80,
            slidesPerView: 4,
          },
        },
      });
      

      var sliderContent = new Swiper(".slider-content", {
        loop: true,
        slidesPerView: 1,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 20,
        allowTouchMove: true,
        navigation: {
          nextEl: ".swiper-button-prev",
          prevEl: ".swiper-button-next",
        },
        thumbs: {
          swiper: sliderThumbnail
        }
      });


      sliderThumbnail.on("slideChangeTransitionStart", function () {
        sliderContent.slideTo(sliderThumbnail.activeIndex);
      });
      sliderContent.on("transitionStart", function () {
        sliderThumbnail.slideTo(sliderContent.activeIndex);
      });


      
      // sliderThumbnail.controller.control = sliderContent;
      // sliderContent.controller.control = sliderThumbnail;
    },
    TabSlider: function () {
 
      
      class TabSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          let next = this.querySelector(".swiper-button-next");
          let prev = this.querySelector(".swiper-button-prev");
      var sliderTab = new Swiper('.slider-tab', {
        centeredSlides: false,
        centeredSlidesBounds: true, 
        direction: "horizontal",
        spaceBetween: 55,
        slidesPerView: 4,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          359: {
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: "auto",
            spaceBetween: 55,
          }
        },
      });
      
      
      var sliderTabContent = new Swiper(".slider-tab-content", {
        loop: true,
        slidesPerView: 1,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 0,
        allowTouchMove: true,
        thumbs: {
          swiper: sliderTab
        }
      });
      
      
      sliderTab.on("slideChangeTransitionStart", function () {
        sliderTabContent.slideTo(sliderTab.activeIndex);
      });
      sliderTabContent.on("transitionStart", function () {
        sliderTab.slideTo(sliderTabContent.activeIndex);
      });
    }

  }

      customElements.define("tab-swiper", TabSwiper);
      
      // sliderThumbnail.controller.control = sliderContent;
      // sliderContent.controller.control = sliderThumbnail;
    },
    collapsibleContent: function () {


      if (!customElements.get("collapsible-content")) {
        class CollapsibleContent extends HTMLElement {
          constructor() {
            super();
            this.disclosure = this.querySelector('details');
            this.toggle = this.querySelector('summary');
            this.panel = this.toggle?.nextElementSibling;
            this.handleToggle = this.handleToggle.bind(this);
            this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
            this.init();
          }
      
          init() {
            if (!this.panel) return; // Safety check if panel not found
      
            const hasTransition = window.getComputedStyle(this.panel).transitionDuration !== '0s';
      
            if (hasTransition) {
              this.toggle.addEventListener('click', this.handleToggle);
              this.disclosure.addEventListener('transitionend', this.handleTransitionEnd);
            }
          }
      
          handleToggle(evt) {
            evt.preventDefault();
      
            if (!this.disclosure.open) {
              this.open();
            } else {
              this.close();
            }
          }
      
          handleTransitionEnd(evt) {
            if (evt.target !== this.panel) return;
      
            if (this.disclosure.classList.contains('is-closing')) {
              this.disclosure.classList.remove('is-closing');
              this.disclosure.open = false;
            }
      
            this.panel.removeAttribute('style');
          }
      
          addContentHeight() {
            const height = this.panel.scrollHeight;
            if (height > 0) {
              this.panel.style.height = `${height}px`;
            } else {
              this.panel.style.height = null;
            }
          }
      
          open() {
            if (!this.panel) return;
      
            const height = this.panel.scrollHeight;
            if (height === 0) {
              this.disclosure.open = true; // No animation needed
              return;
            }
      
            this.panel.style.height = '0px';
            this.disclosure.open = true;
            requestAnimationFrame(() => {
              this.addContentHeight();
            });
          }
      
          close() {
            if (!this.panel) return;
      
            const height = this.panel.scrollHeight;
            if (height === 0) {
              this.disclosure.open = false;
              return;
            }
      
            this.addContentHeight();
            this.disclosure.classList.add('is-closing');
      
            requestAnimationFrame(() => {
              this.panel.style.height = '0px';
            });
          }
        }
      
        customElements.define('collapsible-content', CollapsibleContent);
      }
      

      // if (!customElements.get("collapsible-content")) {
      //   class collapsibleContent extends HTMLElement {
      //     constructor() {
      //       super();
      //       this.disclosure = this.querySelector('details');
      //       this.toggle = this.querySelector('summary');
      //       this.panel = this.toggle.nextElementSibling;
      //       this.init();
      //     }

      //     init() {
      //       // Check if the content element has a CSS transition.
      //       if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
      //         this.toggle.addEventListener('click', this.handleToggle.bind(this));
      //         this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
      //       }
      //     }

      //     /**
      //      * Handles 'click' events on the summary element.
      //      * @param {object} evt - Event object.
      //      */
      //     handleToggle(evt) {
      //       evt.preventDefault();

      //       if (!this.disclosure.open) {
      //         this.open();
      //       } else {
      //         this.close();
      //       }
      //     }

      //     /**
      //      * Handles 'transitionend' events on the details element.
      //      * @param {object} evt - Event object.
      //      */
      //     handleTransitionEnd(evt) {
      //       if (evt.target !== this.panel) return;

      //       if (this.disclosure.classList.contains('is-closing')) {
      //         this.disclosure.classList.remove('is-closing');
      //         this.disclosure.open = false;
      //       }

      //       this.panel.removeAttribute('style');
      //     }

      //     /**
      //      * Adds inline 'height' style to the content element, to trigger open transition.
      //      */
      //     addContentHeight() {
      //       this.panel.style.height = `${this.panel.scrollHeight}px`;
      //     }

      //     /**
      //      * Opens the details element.
      //      */
      //     open() {
      //       // Set content 'height' to zero before opening the details element.
      //       this.panel.style.height = '0';

      //       // Open the details element
      //       this.disclosure.open = true;

      //       // Set content 'height' to its scroll height, to enable CSS transition.
      //       this.addContentHeight();
      //     }

      //     /**
      //      * Closes the details element.
      //      */
      //     close() {
      //       // Set content height to its scroll height, to enable transition to zero.
      //       this.addContentHeight();

      //       // Add class to enable styling of content or toggle icon before or during close transition.
      //       this.disclosure.classList.add('is-closing');

      //       // Set content height to zero to trigger the transition.
      //       // Slight delay required to allow scroll height to be applied before changing to '0'.
      //       setTimeout(() => {
      //         this.panel.style.height = '0';
      //       });
      //     }
      //   }
      //   customElements.define('collapsible-content', collapsibleContent);
      // }
    },
    buyNowButton: function () {
      class ShopifyBuyNowHandler {
        constructor() {
          this.initials();
        }

        initials() {
          document.querySelectorAll('.buy-now-js').forEach((button) => {
            button.addEventListener('click', (e) => this.handleClick(e, button));
          });
        }

        handleClick(e, button) {
          e.preventDefault();

          const form = button.closest('form');
          if (!form) return;

          button.classList.add('loading');
          const spinner = button.querySelector('.loading__spinner_cricle');
          if (spinner) spinner.classList.remove('hidden');

          const formData = new FormData(form);
          const url = '/cart/add.js';

          fetch(url, {
            method: 'POST',
            body: formData, // Shopify expects FormData, not JSON
          })
            .then((response) => {
              if (!response.ok) throw new Error('Failed to add item');
              return response.json();
            })
            .then(() => {
              button.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
              window.location.href = '/checkout'; // Direct call instead of this.redirectToCheckout()
            })
            .catch((error) => {
              console.error('Error adding to cart:', error);
              button.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            });
        }
      }
      // Initialize Immediately
      new ShopifyBuyNowHandler();

      
    }
  },
};


document.addEventListener('DOMContentLoaded', function () {
  Thm.init();
});



class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.option = this.querySelector(".color-swatch__radio");
    this.variantId = this.option.dataset.variantId;
    this.productHandle = this.option.dataset.productHandle;
    this.productCard = this.option.closest(".product-card-wrapper");
    this.form = this.productCard.querySelector(".form");
    this.option.addEventListener("change", this.onSwatchChange.bind(this));

  // if (this.option.checked) {
  //   this.onSwatchChange();
  // }


  }

  onSwatchChange() {
    let url = `${window.shopUrl}/products/${this.productHandle}?variant=${this.variantId}&view=colorswatch`;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        if( this.form != null){
          this.form.querySelector('input[name="id"]').value = this.variantId;
        }
   
        this.updatePrice(html);
        this.updateThumbnail(html);
        this.cardBadge(html);
        this.cartButton(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateThumbnail(html) {

    const media = this.productCard.querySelector(".media");

    if(media != null){
      const destination = media.querySelector("img:first-child");


    const source = html.querySelector(".product__media-item.is-active").querySelector(".product__media img");
    if (source && destination) {
      destination.src = source.src;
      destination.srcset = source.srcset;
    }
    }


  }

  updatePrice(html) {
    const destination = this.productCard.querySelector(".price__container");
    const source = html.querySelector(".price__container");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }
  cardBadge(html) {
    const destination = this.productCard.querySelector(".card__badge");
    const source = html.querySelector(".card__badge");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  cartButton(html) {
    const destination = this.productCard.querySelector(".quick-add__submit");
    const source = html.querySelector(".quick-add__submit");
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    destination.removeAttribute("aria-disabled");
    }

  }
}
customElements.define("color-swatch", ColorSwatch);



class TabScroller extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const swiperContainer = this.querySelector('.tab-slider');

    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
      slidesPerView: "auto",
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 0,
        }
      },
      on: {
        slideChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          const button = activeSlide.querySelector('button'); // Adjust selector as needed
          if (button) {
            button.click();
          }
        }
      }
    });
  }
}

customElements.define('tab-scroller', TabScroller);




// product-rating



 // Get all divs
 const divs = document.querySelectorAll('div[data-target]');


 if(divs != null){
  divs.forEach(div => {
    div.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
 }


 
 function truncateHTMLContent(element, charLimit) {
  let content = element.innerHTML;
  let div = document.createElement("div");
  div.innerHTML = content;

  let totalChars = 0;
  let firstPart = "";
  let secondPart = "";

  function walk(node) {
      if (totalChars >= charLimit) {
          secondPart += node.outerHTML || node.textContent;
          return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
          let text = node.textContent;
          if (totalChars + text.length <= charLimit) {
              firstPart += text;
              totalChars += text.length;
          } else {
              let slice = text.slice(0, charLimit - totalChars);
              firstPart += slice;
              secondPart += text.slice(charLimit - totalChars);
              totalChars = charLimit;
          }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
          let tempStart = `<${node.nodeName.toLowerCase()}`;
          [...node.attributes].forEach(attr => {
              tempStart += ` ${attr.name}="${attr.value}"`;
          });
          tempStart += ">";

          let tempEnd = `</${node.nodeName.toLowerCase()}>`;

          let originalFirstPart = firstPart;
          firstPart += tempStart;
          for (let child of node.childNodes) {
              walk(child);
          }
          firstPart += tempEnd;

          if (totalChars >= charLimit && originalFirstPart === firstPart) {
              secondPart += node.outerHTML;
          }
      }
  }

  for (let node of div.childNodes) {
      walk(node);
  }

  return { firstPart, secondPart };
}

document.querySelectorAll(".add-read-more").forEach(function (element) {
  const charLimit = element.getAttribute("data-char-limit") ? parseInt(element.getAttribute("data-char-limit")) : 300;
  if (element.querySelector(".first-section")) return;

  const { firstPart, secondPart } = truncateHTMLContent(element, charLimit);

  if (secondPart.length > 0) {
      const plusSVG = `
          <svg class="icon-plus" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.49762 2.93384V14.0967" stroke="#334249" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2.9162 8.51532H14.0791" stroke="#334249" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;

      const minusSVG = `
          <svg class="icon-minus" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.9162 8.51532H14.0791" stroke="#334249" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;

      const strToAdd = `
          <span class="first-section">${firstPart}</span>
          <span class="second-section">${secondPart}</span>
          <span class="read-toggle">
              <span class="toggle-text">Read more</span>
              <span class="toggle-icon">${plusSVG}</span>
          </span>`;
      element.innerHTML = strToAdd;

      const toggle = element.querySelector(".read-toggle");
      const secondSection = element.querySelector(".second-section");
      const toggleText = toggle.querySelector(".toggle-text");
      const toggleIcon = toggle.querySelector(".toggle-icon");

      toggle.addEventListener("click", function () {
          const isExpanded = secondSection.style.display === "inline" || secondSection.style.display === "block";
          if (isExpanded) {
              secondSection.style.display = "none";
              toggleText.textContent = "Read more";
              toggleIcon.innerHTML = plusSVG;
          } else {
              secondSection.style.display = "block";
              toggleText.textContent = "Read less";
              toggleIcon.innerHTML = minusSVG;
          }
      });
  }
});


function handleScroll() {
  const btn = document.querySelector('.product-cart-sticky');
  const sticky = document.querySelector('.product-sticky-wrapper');
  if (!btn || !sticky) return;
  const bottom = btn.offsetTop + btn.offsetHeight;
  const top = window.scrollY;
  sticky.classList.toggle('show-sticky', top >= bottom);
}

window.addEventListener('scroll', handleScroll);

if (Shopify.designMode) {
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:block:select', 'shopify:block:deselect']
    .forEach(e => document.addEventListener(e, handleScroll));
}







document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('.category-menu__item');
  const productGrid = document.getElementById('ProductGridContainer');

  if(productGrid != null ){
    menuItems.forEach(item => {
      item.addEventListener('click', function (e) {
        e.preventDefault(); // Stop default link behavior
  
        const url = this.getAttribute('href');
  
        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
  
            // Adjust this selector based on your site's structure
            const newProducts = doc.querySelector('#ProductGridContainer');
  
            if (newProducts) {
              productGrid.innerHTML = newProducts.innerHTML;
            }
  
            // Update active class
            document.querySelectorAll('.category-menu__item').forEach(link => {
              link.classList.remove('category-menu__item--active');
            });
            this.classList.add('category-menu__item--active');
  
            // Optionally update browser URL
            window.history.pushState({}, '', url);
          })
          .catch(error => {
            console.error('Error loading collection:', error);
          });
      });
    });
  }

});